import ServicesConfig from '@/config/ServicesConfig';
import Axios from "axios";

export default {
  getNotifications(page, size, sortBy, descending, any) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("accessToken")

    return Axios.get(ServicesConfig.PUSH_NOTIFICATION.SEARCH, {
      params: {
        page: page,
        size: size,
        sortBy: sortBy,
        descending: descending,
        any: any
      }
    });
  },
  createNotification(notification) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("accessToken")
    return Axios.post(ServicesConfig.PUSH_NOTIFICATION.CREATE, notification);
  }
};